var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83263 22.341L1.60701 23.447V10.1751L7.83263 9.06909V22.341Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83263 22.341L14.0726 23.447V10.1751L7.83263 9.06909V22.341Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2983 22.341L14.0726 23.447V10.1751L20.2983 9.06909V22.341Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6227 6.43176C16.6227 7.08725 16.3065 8.12028 15.7099 9.4122C15.131 10.6658 14.3505 12.0346 13.5571 13.3137C12.7658 14.5894 11.9728 15.7583 11.3769 16.6092C11.3125 16.7011 11.2504 16.7893 11.191 16.8734C11.1315 16.7893 11.0695 16.7011 11.0051 16.6092C10.4091 15.7583 9.61619 14.5894 8.8249 13.3137C8.0315 12.0346 7.25096 10.6658 6.67206 9.4122C6.07548 8.12028 5.75922 7.08725 5.75922 6.43176C5.75922 4.99117 6.33149 3.60958 7.35014 2.59093C8.36879 1.57227 9.75038 1 11.191 1C12.6316 1 14.0132 1.57227 15.0318 2.59093C16.0505 3.60958 16.6227 4.99117 16.6227 6.43176Z",
    fill: "#167ACF",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1902 8.57568C12.3743 8.57568 13.3342 7.61582 13.3342 6.43176C13.3342 5.24771 12.3743 4.28784 11.1902 4.28784C10.0062 4.28784 9.04633 5.24771 9.04633 6.43176C9.04633 7.61582 10.0062 8.57568 11.1902 8.57568Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.129,
    height: 15.4839,
    fill: "white",
    transform: "translate(0.888123 8.51611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3424b0494f476bf999a96e7fd63bc9f9.svg";
export { ForwardRef as ReactComponent };